import developmentConfig from "./development";
import productionConfig from "./production";
import testConfig from "./test";
import dockerConfig from "./docker";

var is_production = false;
var config = developmentConfig;

if (process.env.VUE_APP_CONFIG_TYPE == "docker") {
  config = dockerConfig;
  is_production = true;
} else if (process.env.VUE_APP_CONFIG_TYPE == "production") {
  config = productionConfig;
  is_production = true;
} else if (process.env.VUE_APP_CONFIG_TYPE == "test") {
  config = testConfig;
}

export default {
  is_production: is_production,
  config: config,
  SECUREDWSNAME: "test",
  SECUREDWSPASS: "test",
  MAPBOX_TOKEN: "pk.eyJ1Ijoia2F1c2FuYS10ZWNobyIsImEiOiJjbHMyNnR0OXEwODNkMmpuem85NHUwc3h1In0.ne7txHeYQQr7YBMer1uetw",
  HERE_MAPS_API_KEY: "AT73Ue4ueKYQ8D654JVKEuUNUjN9VQEmKs-AieugfYQ",
  DEFAULT_LATITUDE: -33.45694,
  DEFAULT_LONGITUDE: -70.64827,
  DEFAULT_ZOOM: 12,
  //Keys de Turnstile (Recaptcha Cloudfare)
  SECRET_KEY: "0x4AAAAAABrTBFsBx7n5GzwVVNaAXWGmG5U",
  SITE_KEY: "0x4AAAAAABrTBDH8EOIRbsPy"
};
